import React from 'react';
import { Grid, Spinner } from "@chakra-ui/react"

const FullPageSpinner = ({size='lg', height='40vh', ...rest}) => (
  <Grid justifyContent='center' alignItems='center' height={height}>
    <Spinner size={size} {...rest}/>
  </Grid>
)

export default FullPageSpinner;